import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';
// eslint-disable-next-line import/no-cycle
import { PhotoSizeType } from '.';

export const getSize = (size: PhotoSizeType) => {
  if (size === 'small') {
    return 150;
  }
  if (size === 'large') {
    return 280;
  }
  return 200;
};

export const StyledContainer = styled.div<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  border: `2px solid ${theme.palette.grey[400]}`,
  borderRadius: '100%',
  padding: theme.spacing(0.75),
  position: 'relative',
  transition: theme.transitions.create('border'),
  '&.primary': {
    border: `2px solid ${theme.colors.paletteFromBO.secondary}`,
  },
  '&.secondary': {
    border: `2px solid ${theme.colors.paletteFromBO.secondary}`,
  },
}));

export const StyledCircle = styled.div<{ size: PhotoSizeType }>(({ size }) => ({
  borderRadius: '100%',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
  width: getSize(size),
}));

export const StyledUserPhotoImage = styled.img<{
  size: PhotoSizeType;
  disabled: boolean;
}>(({ size, disabled }) => ({
  display: 'block',
  filter: disabled ? 'grayscale(100%)' : '',
  height: getSize(size),
}));
